import '@/class-component-hooks.ts'
import Vue from 'vue'
import VConfirmDialog from 'vuetify-confirm'
import AutoVirtualScrollList from '@/components/shared/vue-auto-virtual-scroll-list'  
import '@/filters/formatDate'
import '@/filters/typeOffre'
import '@/filters/fluxType'
import '@/filters/compressionMode'
import App from './App.vue'
import VueRouter from './router'
import StoreHelper from './plugins/storeHelper'
import store from './store'
import vuetify from './plugins/vuetify'
import CheckState from '@/components/shared/CheckState.vue'
//@ts-ignore
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false

Vue.component('auto-virtual-scroll-list', AutoVirtualScrollList) 
Vue.component('check-state', CheckState) 

Vue.use(StoreHelper)
Vue.use(VConfirmDialog,{vuetify})
Vue.use(VueVirtualScroller)
Vue.use(VueClipboard)

export const router = VueRouter(store)

new Vue({
  router,
  store,
  //@ts-ignore
  vuetify,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')

